import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import sonsGeronimoImage from "@/assets/sons-geronimo-waterfront.jpg";
import sonsRioCiboloImage from "@/assets/sons-rio-cibolo.jpg";
import sonsRiverRanchImage from "@/assets/sons-river-ranch.jpg";
import sonsBlueRiverCampImage from "@/assets/sons-blue-river-camp.jpg";
import sonsGuadalupeImage from "@/assets/sons-guadalupe.jpg";

const properties = [
  {
    name: "Son's Rio Cibolo",
    description: "100-acre retreat near San Antonio",
    link: "https://sonsriocibolo.com",
    image: sonsRioCiboloImage,
  },
  {
    name: "Son's Geronimo",
    description: "21 waterfront cabins near New Braunfels",
    link: "https://sonsgeronimo.com",
    image: sonsGeronimoImage,
  },
  {
    name: "Son's River Ranch",
    description: "San Marcos River tubing",
    link: "https://sonsriverranch.com",
    image: sonsRiverRanchImage,
  },
  {
    name: "Son's Blue River Camp",
    description: "8 acres on San Marcos River",
    link: "https://bluerivercamp.com/",
    image: sonsBlueRiverCampImage,
  },
  {
    name: "Son's Guadalupe",
    description: "Guadalupe River tubing",
    link: "https://sonsguadalupe.com",
    image: sonsGuadalupeImage,
  },
];

const OtherProperties = () => {
  return (
    <section className="py-20 lg:py-28 bg-secondary/50">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Explore the Son's Island Getaways, LLC. Family
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Six unique waterfront properties across the Texas Hill Country.
          </p>
        </motion.div>

        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 snap-x snap-mandatory scrollbar-hide">
          {properties.map((property, index) => (
            <motion.a
              key={property.name}
              href={property.link}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex-shrink-0 w-64 snap-center group"
            >
              <div className="bg-background rounded-2xl overflow-hidden h-full border border-border/50 shadow-soft hover:shadow-medium transition-all hover:-translate-y-1">
                {property.image && (
                  <img
                    src={property.image}
                    alt={property.name}
                    className="w-full h-32 object-cover"
                  />
                )}
                <div className="p-6">
                  <h3 className="font-display text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                    {property.name}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4">{property.description}</p>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-accent group-hover:gap-2 transition-all">
                    Learn More
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OtherProperties;
